import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

function createKasirSurangLibrary() {
  return {
    tab: 'elements',
    items: [],
    fonts: [],
    categories: [],
    fontStyles: [],
    accessLevels: ['free', 'pro'],
    modalElement: false,
    modalFont: false,
    saving: false,
    aliasesText: '',
    elementForm: { id: null, name: '', category: 'shapes', access: 'free', path: '', is_active: true, file: null },
    fontForm: { id: null, name: '', family: '', access: 'free', styles: ['regular'], is_active: true, file: null },

    init() {
      const cfg = JSON.parse(this.$el.getAttribute('data-config') || '{}');
      this.items = cfg.items || [];
      this.fonts = cfg.fonts || [];
      this.categories = cfg.categories || ['shapes', 'photos'];
      this.fontStyles = cfg.fontStyles || ['regular'];
      this.accessLevels = cfg.accessLevels || ['free', 'pro'];
    },

    openCreateElement() {
      this.elementForm = { id: null, name: '', category: this.categories[0] || 'shapes', access: 'free', path: '', is_active: true, file: null };
      this.aliasesText = '';
      this.modalElement = true;
    },

    editElement(a) {
      this.elementForm = {
        id: a.id,
        name: a.name,
        category: a.category,
        access: a.access || 'free',
        path: a.path || a.url || '',
        is_active: !!a.is_active,
        file: null,
      };
      this.aliasesText = (a.aliases || []).join(', ');
      this.modalElement = true;
    },

    elementPayload() {
      const fd = new FormData();
      fd.append('name', this.elementForm.name);
      if (this.elementForm.slug) fd.append('slug', this.elementForm.slug);
      fd.append('category', this.elementForm.category);
      fd.append('access', this.elementForm.access);
      if (this.elementForm.path) fd.append('path', this.elementForm.path);
      fd.append('is_active', this.elementForm.is_active ? '1' : '0');
      this.aliasesText.split(',').map((s) => s.trim()).filter(Boolean).forEach((a) => fd.append('aliases[]', a));
      if (this.elementForm.file) fd.append('file', this.elementForm.file);
      return fd;
    },

    async saveElement() {
      this.saving = true;
      try {
        const fd = this.elementPayload();
        if (this.elementForm.id) {
          fd.append('_method', 'PUT');
          await axios.post(`/api/v1/kasir/engagement/surang-library/${this.elementForm.id}`, fd);
        } else {
          await axios.post('/api/v1/kasir/engagement/surang-library', fd);
        }
        await this.reloadElements();
        this.modalElement = false;
        window.toast?.('Elemen disimpan.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menyimpan elemen.', 'error');
      } finally {
        this.saving = false;
      }
    },

    async removeElement(a) {
      if (!confirm('Hapus elemen ini?')) return;
      try {
        await axios.delete(`/api/v1/kasir/engagement/surang-library/${a.id}`);
        this.items = this.items.filter((x) => x.id !== a.id);
        window.toast?.('Dihapus.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menghapus.', 'error');
      }
    },

    openCreateFont() {
      this.fontForm = { id: null, name: '', family: '', access: 'free', styles: ['regular'], is_active: true, file: null };
      this.modalFont = true;
    },

    editFont(f) {
      this.fontForm = {
        id: f.id,
        name: f.name,
        family: f.family,
        access: f.access || 'free',
        styles: f.styles || ['regular'],
        is_active: !!f.is_active,
        file: null,
      };
      this.modalFont = true;
    },

    toggleFontStyle(style, on) {
      const set = new Set(this.fontForm.styles || []);
      if (on) set.add(style);
      else set.delete(style);
      this.fontForm.styles = set.size ? [...set] : ['regular'];
    },

    fontPayload() {
      const fd = new FormData();
      fd.append('name', this.fontForm.name);
      fd.append('family', this.fontForm.family);
      fd.append('access', this.fontForm.access);
      fd.append('is_active', this.fontForm.is_active ? '1' : '0');
      (this.fontForm.styles || []).forEach((s) => fd.append('styles[]', s));
      if (this.fontForm.file) fd.append('file', this.fontForm.file);
      return fd;
    },

    async saveFont() {
      this.saving = true;
      try {
        const fd = this.fontPayload();
        if (this.fontForm.id) {
          fd.append('_method', 'PUT');
          await axios.post(`/api/v1/kasir/engagement/surang-fonts/${this.fontForm.id}`, fd);
        } else {
          await axios.post('/api/v1/kasir/engagement/surang-fonts', fd);
        }
        await this.reloadFonts();
        this.modalFont = false;
        window.toast?.('Font disimpan.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menyimpan font.', 'error');
      } finally {
        this.saving = false;
      }
    },

    async removeFont(f) {
      if (!confirm('Hapus font ini?')) return;
      try {
        await axios.delete(`/api/v1/kasir/engagement/surang-fonts/${f.id}`);
        this.fonts = this.fonts.filter((x) => x.id !== f.id);
        window.toast?.('Dihapus.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menghapus.', 'error');
      }
    },

    async reloadElements() {
      const { data } = await axios.get('/api/v1/kasir/engagement/surang-library');
      this.items = data.data || [];
    },

    async reloadFonts() {
      const { data } = await axios.get('/api/v1/kasir/engagement/surang-fonts');
      this.fonts = data.data || [];
    },
  };
}

Alpine.data('kasirSurangLibrary', createKasirSurangLibrary);
